import { useQuery } from '@tanstack/react-query';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';

import { get } from 'app/shared/utils/fetchr';
import { OrgSettingsResponse } from 'app/modules/orgSettings/responses';
import { ORG_SETTINGS_QUERY_KEYS } from 'app/modules/orgSettings/queries/keys';
import { updateOrgSettings } from 'app/modules/orgSettings/sliceOrgSettings';
import { selectStartSessionLoading } from 'app/modules/session/selectors';

export const useGetOrgSettings = () => {
  const dispatch = useDispatch();
  const startSessionLoading = useSelector(selectStartSessionLoading);

  const query = useQuery<OrgSettingsResponse>({
    queryKey: ORG_SETTINGS_QUERY_KEYS.getSettings(),
    queryFn: () => get<OrgSettingsResponse>('/v1/orgs/settings'),
    staleTime: Infinity,
    // Fire only once session init has loaded the real agent
    enabled: !startSessionLoading,
  });

  const { data } = query;

  useEffect(() => {
    if (data) {
      dispatch(updateOrgSettings(data));
    }
  }, [data, dispatch]);

  return query;
};
